import {
  IAuthProvider,
  AuthUser,
  AuthResult,
  MerchantProfile,
  SignUpResult,
} from "../../types";


// Implement with Cloudflare Access / Workers KV / D1 when migrating.
// Required env vars:
//   REACT_APP_CLOUDFLARE_AUTH_URL
//   REACT_APP_CLOUDFLARE_CLIENT_ID
class CloudflareAuthProvider implements IAuthProvider {
  async signIn(_email: string, _password: string): Promise<AuthResult> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async signInWithCustomToken(
    _token: string,
    _tenantId?: string | null,
  ): Promise<AuthResult> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async signOut(): Promise<void> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async signUp(_email: string, _password: string): Promise<SignUpResult> {
    throw new Error("CloudflareAuthProvider.signUp is not implemented yet.");
  }

  getCurrentMerchant(): AuthUser | null {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  onAuthStateChanged(_callback: (user: AuthUser | null) => void): () => void {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async getEmailByMerchantId(_cardNumber: string): Promise<string | null> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async getMerchantProfile(_uid: string): Promise<MerchantProfile> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async getMustChangePassword(_uid: string): Promise<boolean> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async sendPasswordReset(_email: string, _continueUrl?: string): Promise<void> {
    throw new Error("CloudflareAuthProvider.sendPasswordReset is not implemented yet.");
  }

  async reauthenticate(_currentPassword: string): Promise<void> {
    throw new Error("CloudflareAuthProvider.reauthenticate is not implemented yet.");
  }

  async changePassword(_newPassword: string): Promise<void> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }

  async getToken(): Promise<string | null> {
    throw new Error("CloudflareAuthProvider is not implemented yet.");
  }
}

export default CloudflareAuthProvider;
